import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	shortcutIconLabel: {
		id: 'development-summary-pull-request.create-pull-request-summary-item.create-pull-request-dropdown.create-pull-request-target-row.shortcut-icon-label',
		defaultMessage: 'Open link in a new tab',
		description: 'Icon that represents that the corresponding link will open in a new tab',
	},
});
